import { useCompanyWhiteLabelLogo } from '@/src/hooks/useCompanyLogo.hook'
import { Image } from '@chakra-ui/react'
import { FlexRow } from '@components'
import type { FC } from 'react'

interface NavbarWhiteLabelLogoProps {
  companyId?: number
  whiteLabelLogoId?: number | null
}

export const NavbarWhiteLabelLogo: FC<NavbarWhiteLabelLogoProps> = ({ companyId, whiteLabelLogoId }) => {
  const { data: logoUrl } = useCompanyWhiteLabelLogo(companyId, whiteLabelLogoId)

  return (
    <FlexRow mt='28px' ml={6}>
      {!!logoUrl && <Image objectFit='cover' src={logoUrl} maxWidth='210px' maxHeight='160px' />}
    </FlexRow>
  )
}
